import React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";


export default function TopCustomersHead() {

    return (
        <TableHead>
            <TableRow sx={{borderBottom: "2px solid var(--mc1)"}}>
                <TableCell sx={{fontWeight: "bold", fontSize: "16px"}}>رتبه</TableCell>
                <TableCell sx={{fontWeight: "bold", fontSize: "16px"}}>نام و نام خانوادگی</TableCell>
                <TableCell sx={{fontWeight: "bold", fontSize: "16px"}}>امتیاز</TableCell>
            </TableRow>
        </TableHead>
    );
  }